import { ThemeProvider } from '@mui/material';
import { Api } from 'apis';
import { AxiosError } from 'axios';
import CandidateForm from 'components/refme/CandidateForm';
import Header from 'components/refme/Header';
import { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { refmeTheme } from 'utils/theme';

const CandidateProfile: React.FC = () => {
	const navigate = useNavigate();

	const token = localStorage.getItem('access');
	const redirectURL = location.pathname + location.search;
	useEffect(() => {
		const checkAuth = async () => {
			try {
				await Api.get(`api/questionnaire`);
			} catch (err) {
				if ((err as AxiosError).status === 401) {
					console.log(redirectURL);
					navigate('/signin', {
						state: {
							redirectURL,
						},
					});
				} else {
					console.log(err);
				}
			}
		};
		checkAuth();
	}, []);

	if (!token) {
		return (
			<Navigate
				to='/signin'
				replace
				state={{ redirectURL: location.pathname + location.search }}
			/>
		);
	}

	return (
		<div className='pb-20'>
			<Header />
			<ThemeProvider theme={refmeTheme}>
				<CandidateForm />
			</ThemeProvider>
		</div>
	);
};

export default CandidateProfile;
